import NoSearchResult from './NoSearchResult';
import './NoSearchResult.scss';

export default NoSearchResult;
